import React, { useState } from "react";
import ProductCard from "./ProductCard";
import useSession from "../hooks/useSession";

const ProductGrid = ({products}) => {

	const { isAuthenticated } = useSession();
	const [maxItemsToShow, setMaxItemsToShow] = useState(30);

	const handleShowMore = () => {
		setMaxItemsToShow((prevMaxItemsToShow) => prevMaxItemsToShow + 30);
	};

	if (!products || products.length === 0) {
		return <p className="text-sm text-muted">No hay productos para mostrar.</p>;
	}

	return (
		<div className="text-center">
			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
				{
					products.slice(0, maxItemsToShow).map((product, index) => (
						<ProductCard product={ product } key={ index } showPrice={ isAuthenticated }/>
					))
				}
			</div>
			{
				products.length > maxItemsToShow
                &&
                <button onClick={handleShowMore} className="button button--primary mt-8">Mostrar más</button>
			}
		</div>
	);
};

export default ProductGrid;
